import React from "react";
import Footer from "../../Footer/Footer";
import NavBar1 from "../../Navbar1/NavBar1";
// import "../style/style-2.6.0.css";
import "../style/minimal_style.css";
export default function AboutUs() {
  return (
    <React.Fragment>
      <NavBar1 />
      <Footer>
        <div className="container mb-3">
          <main id="main">
            <div class="container">
              <div class="page-header">
                <h1 class="page-title">About Us</h1>
              </div>
              <div class="page-content">
                We are K5Fitness We are simply known for delivering genuine
                sports nutrition supplements to health enthusiasts at very
                affordable rates. We offer a humongous range of health products
                across categories and all major brands
                <p>
                  K5Fitness is a natural and herbal supplement company, founded
                  for the sole purpose of unlocking the hidden benefits of
                  nature to provide everyday goodness and wellness to people
                  across the globe. Our countless happy and healthy customers
                  are the living proof of everything we stand for. In fact, we
                  are firm believers and advocates of natural healing for people
                  of all ages and particularly the healing that is derived from
                  nature itself.
                </p>
                <h4>NATURE HAS A CURE FOR EVERYTHING</h4>
                <p>
                  {" "}
                  We live in a society of people addicted to pills, chemical
                  treatments and obsolete beliefs when at the same time, these
                  same people are ridden with chronic diseases, pains and aches
                  and other unexplained symptoms that modern medicine has failed
                  to control. That’s why our supplement line is more than just a
                  way to put bread on our table and a roof over our heads. It is
                  our way of unveiling the benefits of natural ingredients to
                  people who can actually benefit from some support in their
                  journey to health and wellness.
                </p>
                <h4>Our Offerings</h4>
                <h4>Resources </h4>{" "}
                <p>
                  We provide our followers and readers with thousands of
                  write-ups on fitness and workout. These free articles contain
                  valuable data on varied exercises which will assist you to
                  bring home the bacon your goal. you simply ought to fix your
                  goal and that we can assist you with all the mandatory data
                  associated with nutrition, fitness exercises, diet chart,
                  monthly arrange and plenty of additional.
                </p>
                <h4>Find a Plan </h4>{" "}
                <p>
                  All you would like at the start to begin together with your
                  goal may be a plan. We provide free fitness plans that embrace
                  video directions for doing the exercise within the correct
                  manner, daily physical exertion plans, nutrition data, tips
                  for victimization the supplement, email and text inspirations,
                  and plenty of additional. We will additionally assist you to
                  keep a track of your transformation.
                </p>
                <h4>Store </h4>{" "}
                <p>
                  We’ve tie-ups with all the main importers of supplement like
                  Neuvera well-being Pvt. Ltd, Kar Enterprises, Arena Impex,
                  Bright Commodities, world Impex, final Nutrition and plenty of
                  additional. We tend to are one in all the leading approved
                  resellers in Bharat. We’ve additionally obtained the approved
                  marketer tag from these firms.
                </p>
                <h4>Community </h4>{" "}
                <p>
                  k5fitness.in has one in all the quickest growing communities
                  in Bharat. You may get to understand the real-life stories of
                  transformations by those that are on an identical journey.
                  This can keep you intended and assist you to reach achieving
                  your goal. Individuals from across the country are
                  victimization k5fitness.in in their transformation journey.
                </p>
                <h4>Transformation Challenges </h4>{" "}
                <p>
                  Transformation challenges you to your limits. It’s not a
                  one-time accomplishment, rather it’s a lifestyle. You
                  perpetually keep difficult yourself to the high-hanging fruits
                  within the fitness world. We tend to bring you such challenges
                  with engaging prizes. Thus, your passion becomes fun and you
                  profit with this in terms of health also as wealth.
                </p>
              </div>
            </div>
          </main>
        </div>
      </Footer>
    </React.Fragment>
  );
}
